export function onOutsideClick(
  node: HTMLElement,
  { cb, ignoredTargets }: { cb: (event?) => any; ignoredTargets?: HTMLElement[] }
) {
  const controller = new AbortController();
  const { signal } = controller;

  document.addEventListener(
    'click',
    event => {
      // The event is firing three times, not sure why.

      const composedPath = event.composedPath();

      // Ignore ignored targets :)
      for (const ignored of ignoredTargets || []) {
        if (composedPath.includes(ignored)) {
          return;
        }
      }

      if (!composedPath.includes(node)) {
        cb(event);
      }
    },
    { capture: true, signal }
  );

  node.addEventListener(
    'DOMNodeRemoved',
    () => {
      controller.abort();
    },
    { once: true }
  );
}
